/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  ForbiddenResponse,
  GetDiscrepancyResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Discrepancy Details
 */
export const getDiscrepancyDetails = (discrepancyID: string, signal?: AbortSignal) => {
  return customInstance<GetDiscrepancyResponseResponse>({
    url: `/bm-declaration-service/v1/discrepancy/${discrepancyID}`,
    method: 'get',
    signal,
  });
};

export const getGetDiscrepancyDetailsQueryKey = (discrepancyID: string) => {
  return [`/bm-declaration-service/v1/discrepancy/${discrepancyID}`] as const;
};

export const getGetDiscrepancyDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscrepancyDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  discrepancyID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscrepancyDetailsQueryKey(discrepancyID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscrepancyDetails>>> = ({ signal }) =>
    getDiscrepancyDetails(discrepancyID, signal);

  return { queryKey, queryFn, enabled: !!discrepancyID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscrepancyDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscrepancyDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscrepancyDetails>>
>;
export type GetDiscrepancyDetailsQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Discrepancy Details
 */
export const useGetDiscrepancyDetails = <
  TData = Awaited<ReturnType<typeof getDiscrepancyDetails>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  discrepancyID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDiscrepancyDetailsQueryOptions(discrepancyID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
